export const States = {
    LOGIN_INIT: "loginInit",
    LOGGEDIN: "loggedIn",
    LOGOUT: "logout",
    AWAIT_OTP: "awaitOtp", 
    OTP_VERIFICATION_INIT: "otpVerificationInit",
    OTP_VERIFICATION_COMPLETED: "otpVerificationCompleted",
    VERIFIED_OTP: 'verifiedOtp',
    UNDEFINED: "undefined",
}